import { useEffect, useState } from 'react';
import { MenuItem, CircularProgress, Select } from '@mui/material';
import { useAuth } from '../../../modules/auth/context/AuthContext';
import { useQueryClient } from '@tanstack/react-query';
import { useLocation } from 'react-router-dom';

type TenantSelectIfAdminProps = {
  value?: string;
  onChange?: (tenantId: string) => void;
  label?: string;
  disabled?: boolean;
};

export function TenantSelectIfAdmin({
  onChange,
  label = 'Empresa',
  disabled = false,
}: TenantSelectIfAdminProps) {
  const auth = useAuth();
  const [loading, setLoading] = useState(false);
  const queryClient = useQueryClient();
  const location = useLocation();

  const handleChange = async (e: any) => {
    const id = e.target.value.trim(); 
    try {
      const tenant = auth.user.tenants.find((t: any) => t.id === id);
      console.log('Setting tenant:', tenant);
      auth.changeSelectedTenant(tenant);
      if (onChange) onChange(id);

      // Pega o nome da rota atual (ex: /orders, /users, etc)
      const currentRoute = location.pathname.split('/')[1];
      
      // Recarrega os dados da rota atual
      await queryClient.invalidateQueries({ queryKey: [currentRoute] });
    } catch (error) {
      console.log('Error setting tenant:', error);
    }
  };

  return (
    <Select
      value={auth.selectedTenant.id}
      onChange={handleChange}
      fullWidth
      size="medium"
      displayEmpty
      sx={{
        width: '100%',
        fontSize: 16,
        background: '#fff',
        color: '#222',
        fontWeight: 500,
        mt: 0.5,
        mb: 0.5,
        borderRadius: 2,
        textAlign: 'center',
        '& .MuiSelect-select': {
          py: 1.2,
          px: 1.5,
          textAlign: 'center',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        },
      }}
      inputProps={{ 'aria-label': label }}
      disabled={disabled || loading}
    >
      <MenuItem value="" disabled sx={{ justifyContent: 'center', textAlign: 'center' }}>
        <span style={{ color: '#888', width: '100%', display: 'block', textAlign: 'center' }}>Sua Empresa</span>
      </MenuItem>
      {loading ? (
        <MenuItem value="" disabled sx={{ justifyContent: 'center', textAlign: 'center' }}>
          <CircularProgress size={20} />
        </MenuItem>
      ) : (
        auth.user.tenants.map((tenant: any) => (
          <MenuItem key={tenant.id} value={tenant.id} sx={{ justifyContent: 'center', textAlign: 'center' }}>
            {tenant.name}
          </MenuItem>
        ))
      )}
    </Select>
  );
}